@if (isProfileSidebarOpen()) {
<div class="bg-black/20 fixed inset-0 z-3" (click)="closeProfileSidebar()">
</div>

<div role="dialog" aria-modal="true" [attr.aria-label]="'BANNER.SIDEBAR_ARIA' | translate"
  class="bg-linear-to-br from-slate-200 to-blue-100 text-blue-900/80 dark:from-gray-950 dark:to-indigo-950 dark:text-indigo-200 fixed top-0 right-0 h-full w-80 max-w-full z-3 overflow-y-auto">

  <div class="p-6 space-y-8">
    <!-- Header del sidebar -->
    <div class="flex justify-between items-center">
      <h2 class="text-xl font-bold">{{ 'BANNER.MY_PROFILE' | translate }}</h2>
      <button (click)="closeProfileSidebar()" class="text-gray-400">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" class="h-6 w-6" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Información del usuario -->
    <div class="flex flex-col items-center gap-4">
      <img #profileImage [ngSrc]="profilePicture() || imageFallback.getFallbackImage('profile')" width="96" height="96"
        (error)="imageFallback.handleImageError($event, 'profile')" [alt]="'BANNER.PROFILE_ALT' | translate"
        class="border-blue-900/80 dark:border-indigo-200 w-24 h-24 rounded-full object-cover border-2">
      <h3 class="text-lg font-semibold">{{ loggedInUsername() }}</h3>
    </div>

    <!-- Menú de opciones -->
    <div class="space-y-2 text-gray-700 dark:text-gray-300">
      <a (click)="navigateAndClose('/@' + loggedInUsername())" class="flex items-center p-4 rounded-lg">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" class="h-5 w-5 mr-3"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 7a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7" />
        </svg>
        {{ 'BANNER.MY_PROFILE' | translate }}
      </a>

      <a (click)="navigateAndClose('/games/creations')" class="flex items-center p-4 rounded-lg">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" class="h-5 w-5 mr-3"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 11H5m14 0a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2m14 0V9a2 2 0 0 0-2-2M5 11V9a2 2 0 0 1 2-2m0 0V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2M7 7h10" />
        </svg>
        {{ 'BANNER.MY_CREATIONS' | translate }}
      </a>

      <a (click)="navigateAndClose('/cuenta/ajustes')" class="flex items-center p-4 rounded-lg">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" class="h-5 w-5 mr-3"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
        </svg>
        {{ 'BANNER.SETTINGS' | translate }}
      </a>

      <div class="border-t border-gray-600 my-4"></div>

      <a (click)="confirmLogout()" class="text-red-600 dark:text-red-400 flex items-center p-4 rounded-lg">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" class="h-5 w-5 mr-3"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m17 16 4-4m0 0-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1" />
        </svg>
        {{ 'BANNER.LOGOUT' | translate }}
      </a>
    </div>
  </div>
</div>
}

<div
  class="bg-slate-100/80 dark:bg-gray-950/90 text-white border-b border-gray-300 dark:border-gray-700 backdrop-blur-sm flex fixed top-0 left-0 w-full px-6 py-2 z-3">
  @if (!isSearchExpanded()) {
  <a (click)="onLogoClick()">
    <img src="logo.svg" [alt]="'BANNER.LOGO_ALT' | translate" class="h-10">
  </a>
  }

  @if (isNavigating()) {
  <div class="absolute bottom-0 left-0 w-full h-0.5 bg-blue-500 z-2 animate-pulse" style="box-shadow: 0 0 8px #3b82f6;">
  </div>
  }

  <div class="text-gray-700 dark:text-white flex gap-3 items-center w-full justify-end">
    @if (isSearchExpanded()) {
    <input id="mobile-search-input" type="search" name="search" [(ngModel)]="searchQuery"
      (keydown)="onSearchKeydown($event)"
      class="bg-white dark:bg-blue-950/50 placeholder-gray-400 min-w-40 px-4 py-2 rounded-lg shadow-sm focus:outline-none"
      [placeholder]="'BANNER.SEARCH_PLACEHOLDER' | translate" />
    <div class="flex gap-2">
      <button (click)="onSearch()" class="bg-white dark:bg-blue-950/50 p-2 transition-colors rounded-lg shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612T9.5 3t4.612 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5t-1.312-3.188T9.5 5T6.313 6.313T5 9.5t1.313 3.188T9.5 14" />
        </svg>
      </button>
      <button (click)="closeSearchExpanded()" class="text-gray-400">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    } @else {
    <div
      class="bg-white dark:bg-blue-950/50 placeholder-gray-400 hidden sm:flex gap-2 py-2 px-3 text-sm shadow-sm rounded-lg">
      <div class="flex items-center pointer-events-none">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612T9.5 3t4.612 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5t-1.312-3.188T9.5 5T6.313 6.313T5 9.5t1.313 3.188T9.5 14" />
        </svg>
      </div>
      <input type="search" [(ngModel)]="searchQuery" (keydown)="onSearchKeydown($event)" class="focus:outline-none"
        [placeholder]="'BANNER.SEARCH_PLACEHOLDER' | translate" required />
    </div>

    <div class="text-gray-700 dark:text-white sm:hidden flex items-center p-2 rounded-lg"
      (click)="toggleSearchExpanded()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" class="w-5 h-5" viewBox="0 0 20 20">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
      </svg>
    </div>

    <a routerLink="/games/bola8" class="hidden hover:text-blue-400 transition-all">{{ 'BANNER.BOLA_8' | translate }}</a>
    @if (authService.isLoggedIn()) {
    <a routerLink="/create"
      class="bg-linear-to-r from-emerald-600/80 to-blue-700/80 hover:bg-blue-900 text-white px-1 sm:px-3 py-1 rounded-full font-semibold transition-all">
      <span class="sm:hidden"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
        </svg></span><span class="hidden sm:block">{{ 'BANNER.CREATE' | translate }}</span>
    </a>

    @if (userService.userProfile()?.is_pro) {
    <a routerLink="/cuenta/suscripcion"
      class="bg-linear-to-r from-emerald-100 to-cyan-100 dark:from-emerald-950/80 dark:to-cyan-950/80 text-emerald-700 dark:text-emerald-400 border border-dashed border-emerald-700 dark:border-emerald-400 hover:bg-emerald-950 flex items-center gap-1.5 px-3 py-1 rounded-full transition-all">
      <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24" height="24" fill-rule="evenodd"
        clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision" viewBox="0 0 400 400">
        <path id="Capa_x0020_1" fill="currentColor"
          d="M91.98 168.1c4.37-13.4 3.05-68.64 37.4-107.52-6.46 17.64 1.43 61.13 16.32 60.1 8.83-.14 30.49-55.21 37.09-103.13 3.14 31.06 24.43 98.16 43.72 98.5 18-2.14 22.69-41.52 21.29-62.64 44.75 41.58 53.32 83.44 52.78 115.7 7.4 18.58 24.63-37.12 23.6-59.84 234.23 360.05-475.97 365-252.18 10.07-4.94 15.25 12.67 73.54 19.98 48.76m33.86 20.31h26.41l20.43 55.77 33.7-55.77 53.08.6c7.47 1.87 18.94 3.4 22.97 16.36 2.43 7.92 1.04 16.57-.38 28.94-1.05 8.96-2.23 21.05-11.82 30.19-12.54 11.99-32.1 9.52-45.33 9.52l-4.41 40.32h-27.14l7.29-73.05-26.54 38.46-15.15-.8-12.89-48.29-9.37 83.67-27.83-.45zm101.31 62.65 4.76-39.89h14.07c10.53.31 10.18 8.76 8.55 20.22-1.6 11.43-1.35 16.64-9.34 19.18-6.01.49-12.03.31-18.04.49" />
      </svg>
      <span class="text-sm font-semibold">{{ 'BANNER.PRO' | translate }}</span>
    </a>
    } @else {
    <a routerLink="/shop/pro"
      class="bg-linear-to-r from-emerald-600/80 to-emerald-800/80 hover:bg-emerald-800/50 text-white px-3 py-1 rounded-full font-semibold transition-all">
      {{ 'BANNER.UPGRADE_PRO' | translate }}
    </a>
    }
    <div class="dropdown relative group">
      <a class="nav-link cursor-pointer">
        <img [ngSrc]="profilePicture() || ''" height="40" width="40" [alt]="'BANNER.PROFILE_IMG_ALT' | translate"
          class="rounded-full object-cover" (error)="imageFallback.handleImageError($event, 'profile')"
          (click)="navigateProfileOrSidebar()">
      </a>

      <div
        class="bg-slate-200 dark:bg-gray-900 text-gray-700 dark:text-white border border-gray-400 dark:border-gray-700 hidden font-semibold sm:flex flex-col shadow-xl dropdown-content absolute rounded-lg invisible opacity-0 transition-all duration-300 transform translate-y-2 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 z-3 right-0">
        <a routerLink="/cuenta/ajustes" class="dropdown-item block px-4 py-2 hover:text-blue-500">{{ 'BANNER.SETTINGS' |
          translate }}</a>
        <a routerLink="/games/creations" class="dropdown-item block px-4 py-2 hover:text-blue-500">{{
          'BANNER.MY_CREATIONS' | translate }}</a>
        <a (click)="confirmLogout()" class="dropdown-item block px-4 py-2 hover:text-red-500 cursor-pointer">{{
          'BANNER.LOGOUT' | translate }}</a>
      </div>
    </div>
    } @else {
    <a routerLink="/login" class="text-gray-700 dark:text-white hover:text-blue-500 font-semibold">{{ 'BANNER.LOGIN' |
      translate }}</a>
    <a routerLink="/register" class="text-gray-700 dark:text-white hover:text-blue-500 font-semibold">{{
      'BANNER.REGISTER' | translate }}</a>
    }
    }
  </div>
</div>